import styled from 'styled-components';
import { BREAKPOINT, PADDING } from '@latitude/core/utils/constants';

/* layout decision */
const getColumns = num => {
  if (num === 4) return 2;
  if (num >= 5) return 3;
  return num;
};

export const StyledProofPointContainer = styled.div`
  display: flex;
  background-color: white;
  border-radius: 32px;
  border-bottom: none !important;
  text-shadow: none !important;
  padding: ${PADDING.P16} ${PADDING.P32};
  min-height: 80px;

  /* MOBILE — always 1 per row */
  flex: 0 1 100%;
  max-width: 100%;

  @media (min-width: ${BREAKPOINT.MD}) {
    padding: ${PADDING.P32} ${PADDING.P32};
    ${({ numOfPoints }) => {
      const columns = getColumns(numOfPoints);
      return `
        flex: 0 1 calc(100% / ${columns} - 10px);
      `;
    }}
  }
`;

export const StyledProofPointContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
    svg {
    width: 39px;
    height: 39px;
    flex-shrink: 0; /* prevents shrinking in flex */
  }
`;

export const StyledProofPointTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
